import logo from './skg-logo-white.svg'
import { RiLogoutBoxFill } from 'react-icons/ri'

const DashboardNav = ({ logOut }) => {
    return (
        <div
            className="bg-skgBlue p-2"
        >
            <div
                className="max-w-1400 mx-auto h-14 flex divide-x items-center"
            >
                <div
                    className='basis-3/4'
                >
                    <div
                        className='w-44'
                    >
                        <img
                            src={logo}
                        />
                    </div>
                </div>
                <div
                    className='basis-1/4 flex items-center justify-center'
                >
                    <div
                        className="text-white flex items-center cursor-pointer"
                        onClick={
                            logOut
                        }
                    >
                        <RiLogoutBoxFill
                            className='opacity-50'
                            size={25}
                        />
                        <span
                            className='text-sm'
                        >
                            Log af
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardNav;